import {CATALOG_STORE_NAME} from '../reducers/reducers'

export function getCatalogItems(state) {
    const stored = state[CATALOG_STORE_NAME] || { }
    return stored.items
}
